import { Link } from 'react-router-dom'
import {
  BarChart3,
  Upload,
  History,
  Settings,
  HelpCircle,
  Bell,
  User,
} from 'lucide-react'
import { Button } from '@/components/ui'
import { authToken } from '@/services/api'

export function Header() {
  const isAuthed = Boolean(authToken.get())

  const onLogout = () => {
    authToken.clear()
    window.location.reload()
  }

  return (
    <header className="h-16 border-b bg-white sticky top-0 z-50">
      <div className="flex h-full items-center justify-between px-6">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg gradient-header flex items-center justify-center">
            <BarChart3 className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-dashboard-navy">Agentic Suite</h1>
            <p className="text-xs text-muted-foreground">Credit Analysis Dashboard</p>
          </div>
        </Link>

        {/* Center navigation (optional) */}
        <nav className="hidden md:flex items-center gap-1">
          <Link to="/">
            <Button variant="ghost" size="sm" className="gap-2">
              <BarChart3 className="h-4 w-4" />
              Dashboard
            </Button>
          </Link>
          <Link to="/upload">
            <Button variant="ghost" size="sm" className="gap-2">
              <Upload className="h-4 w-4" />
              Upload
            </Button>
          </Link>
          <Link to="/history">
            <Button variant="ghost" size="sm" className="gap-2">
              <History className="h-4 w-4" />
              History
            </Button>
          </Link>
        </nav>

        {/* Right actions */}
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="icon" className="relative">
            <Bell className="h-5 w-5" />
            <span className="absolute top-1 right-1 h-2 w-2 rounded-full bg-risk-critical" />
          </Button>
          <Button variant="ghost" size="icon">
            <HelpCircle className="h-5 w-5" />
          </Button>
          <Button variant="ghost" size="icon">
            <Settings className="h-5 w-5" />
          </Button>
          {isAuthed ? (
            <Button
              variant="ghost"
              size="sm"
              onClick={onLogout}
              className="text-red-600 hover:text-red-700"
            >
              Logout
            </Button>
          ) : null}
          <div className="ml-2 flex items-center gap-2">
            <div className="h-8 w-8 rounded-full bg-gradient-to-br from-dashboard-teal to-dashboard-purple flex items-center justify-center">
              <User className="h-4 w-4 text-white" />
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
